import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import GetRate from "@/components/requests/internal/GetRate.vue";
import ColorType from "@/components/functionals/ColorType.vue";

export async function GetDelayedExteneralRequests(thiss) {
  let Parameters = {
    params: {
      Id: null,
      TechnicianId: null,
      ProductId: null,
      userID: thiss.currentUser.UserID,
      status: 3,
      companyCode: thiss.currentCompany,
      ProspectCode: undefined,
      FromDate: null,
      ToDate: null,
      CustomerService: undefined,
      ServiceRequestTypeId: undefined,
      ClientCode: undefined
    }
  };
  let TableData = [];

  if (
    thiss.currentUser.UserID == 42 || //Nancy
    thiss.currentUser.UserID == 140 //NINOSKA
  ) {
    await thiss.$http
      .get("/api/serviceRequests/GetDelayedExteneralRequests", Parameters)
      .then((response) => {
        let data = response.data;
        TableData = data;
      });
  } else {
    TableData = [];
  }
  return TableData;
}

export const DelayedExternalSupportColumns = [
  {
    prop: "Id",
    label: "NO",
    width: 80,
    sortable: true,
    formatter: SLAClolorStatus
  },
  {
    prop: "CustomerName",
    label: "Cliente",
    minWidth: 300,
    formatter: (row) => {
      if (
        row.CustomerName === "" ||
        row.CustomerName === null ||
        row.CustomerName === undefined
      ) {
        return row.Customer.Name;
      }
      return row.CustomerName;
    }
  },
  {
    label: "Clasificación",
    prop: "Customer.Clasification",
    width: 130,
    sortable: true,
    formatter: (row) => row.Customer.Clasification
  },
  {
    prop: "ServiceRequestType.Description",
    label: "Solictud",
    sortable: true,
    formatter: (row) => {
      return row.ServiceRequestType ? row.ServiceRequestType.Description : "";
    },
    minWidth: 200
  },
  {
    prop: "DeviceQuantity",
    label: "Cantidad",
    align: "center",
    width: 110,
    sortable: true,
    formatter: (row) =>
      row.DeviceQuantity ?? row.DeviceQuantity > 1 ? row.DeviceQuantity : ""
  },
  {
    prop: "Device",
    label: "Equipo",
    width: 80
  },
  {
    prop: "AssignedTechnician.FullName",
    label: "Tecnico",
    minWidth: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnicianImage"
    }
  },
  {
    prop: "SLAHoursToRespond",
    label: "SLA",
    minWidth: 75,
    sortable: true,
    formatter: (row) => {
      return row.SLAHoursToRespond ? row.SLAHoursToRespond : "";
    }
  },
  {
    //prop: "DiasRetraso",
    name: "Retraso",
    label: "center",
    minWidth: 100,
    sortable: true,
    formatter: ColorType
    /*
    formatter: row => {
      return <b style="background-color:powderblue;">$`{row.DiasRetraso + " Dias"}`</b>;
    }
    */
  },
  {
    prop: "RequestDate",
    label: "Creado",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "DueDate",
    label: "Limite",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  },
  {
    prop: "Customer.CustomerService",
    label: "Servicio",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CustomerServiceImage"
    }
  },
  {
    prop: "CreatedByUser.FirstName",
    label: "Creada Por",
    formatter: ImagePerson,
    minWidth: 250,
    sortable: true,
    attrs: {
      imgKey: "CreatedByImage"
    }
  },
  {
    prop: "StatusDescription",
    label: "Estado",
    minWidth: 100
  },
  {
    prop: "NameValidator",
    label: "Validado por",
    formatter: ImagePerson,
    minWidth: 250,
    attrs: {
      imgKey: "imageValidator"
    }
  },
  {
    prop: "Valoracion",
    label: "Calificacion",
    sortable: true,
    formatter: GetRate,
    minWidth: 145
  },
  {
    prop: "ValoracionComents",
    label: "Nota de Calificacion",
    minWidth: 200
  },
  {
    prop: "ServiceRequestCloseDate",
    label: "Fecha Cierre",
    formatter: DatetimeFormatter,
    minWidth: 190,
    sortable: true
  }
];
